// extracted by mini-css-extract-plugin
module.exports = {"glacierH5":"detail_glacierH5__OFV4w"};